
import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';
import ContentMenuCard from "../ContentMenuCard";
import LoadingButton from "../../../Loading/LoadingButton";

import contentNewSubcourse from "../../../contentImgs/online-exam.png";
import Snackbar from "../../../../Snackbar";
import { createNewFolder } from "../../../../store/actions/CreateContent/FolderAPI/FolderAPIs";
import Loading from "../../../Loading/Loading";
import { createNewSubCourse } from "../../../../store/actions/CreateContent/OrganizeAPI/SubCoursesAPIs";
import AddThumbnailSidebar from "../../CreateCourse/AddThumbnailSidebar";
import AddThumbnailSubCourse from "./AddThumbnailSubCourse";
import AddDemoVideosSubCourse from "./AddDemoVideosSubCourse";
import WhatULearnSubCourse from "./WhatULearnSubCourse";
import AddPreRequsitesSubCourse from "./AddPreRequsitesSubCourse";
import AddTargetAudienceSubCourse from "./AddTargetAudienceSubCourse";
import AddSkillsSubCourse from "./AddSkillsSubCourse";
import AddJobScopeSubCourse from "./AddJobScopeSubCourse";
import AddHighlightsSubCourse from "./AddHighlightSubCourse";
import AddFAQsSubCourse from "./AddFAQsSubCourse";
const CreateSubCoursePopUp =({menuOrder,sendBackSubCourse,changeItemData,subCourseItem,setopenAppDesignPopUp})=>{

     const dispatch = useDispatch();
     
        const [snackbarVisible, setSnackbarVisible] = useState(false);
        const [snackbarColor, setSnackbarColor] = useState("#958FDA");
        const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
      
      const showSnackbar = () => {
        setSnackbarVisible(true);
      };
     
      const hideSnackbar = () => {
        setSnackbarVisible(false);
      };


      const [subCourseName ,setSubCourseName] =useState(subCourseItem?.Name?subCourseItem?.Name:"")
      const [subCourseDescription ,setSubCourseDescription] =useState(subCourseItem?.Description?subCourseItem?.Description:"")
      const [subCourseThumbnail ,setSubCourseThumbnail] =useState(subCourseItem?.Thumbnail?subCourseItem?.Thumbnail:"")
      const [subCourseDemoVideos ,setSubCourseDemoVideos] =useState(subCourseItem?.DemoVideos?JSON.parse(subCourseItem?.DemoVideos):[])
      const [subCourseWhatWillULearn ,setSubCourseWhatWillULearn] =useState(subCourseItem?.WhatWillULearn?JSON.parse(subCourseItem?.WhatWillULearn):[])
      const [subCoursePrerequisite ,setSubCoursePrerequisite] =useState(subCourseItem?.Prerequisite?JSON.parse(subCourseItem?.Prerequisite):[])
      const [subCourseTargetAudience ,setSubCourseTargetAudience] =useState(subCourseItem?.TargetAudience?JSON.parse(subCourseItem?.TargetAudience):[])
      const [subCourseSkillEarned ,setSubCourseSkillEarned] =useState(subCourseItem?.SkillEarned?JSON.parse(subCourseItem?.SkillEarned):[])
      const [subCourseJobScope ,setSubCourseJobScope] =useState(subCourseItem?.JobScope?JSON.parse(subCourseItem?.JobScope):[])
      const [subCourseHighlights ,setSubCourseHighlights] =useState(subCourseItem?.Highlights?JSON.parse(subCourseItem?.Highlights):[])
      const [subCourseFAQs ,setSubCourseFAQs] =useState(subCourseItem?.FAQs?JSON.parse(subCourseItem?.FAQs):[])
       const [subCourseID ,setSubCourseID] =useState(subCourseItem?.ID?subCourseItem?.ID:"");
      const [folderMenuOrder ,setSubCourseMenuOrder] =useState(subCourseItem?.menuOrder?subCourseItem?.menuOrder:menuOrder);
      const [showAddFolderEdit ,setShowAddFolderEdit] =useState(subCourseItem?.ID?true:false)
       const [showAddFolderDetails ,setShowAddFolderDetails] =useState(subCourseItem?.ID?true:false)
       
     const [FolderLook ,setFolderLook] =useState("")
           
           
            const [loader , setLoader] =useState({status:false});
      
       const [animate, setAnimate] = useState(false);
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        



      
       const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     
             const appId = useSelector((state)=>state?.app?.app?.ID);
             const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
       useEffect(() => {
         // Trigger the animation after a delay (e.g., 500ms)
         const timer = setTimeout(() => {
          setAnimate(true);  
        }, 100);
      
         return () => clearTimeout(timer); // Cleanup on unmount
       }, []);
      useEffect(()=>{
        // setCourseTitleData();
      },[])
      
      
const handleCreateSubCourse=(e)=>{



setLoader({status:true});
// console.log({Name:subCourseName,
//     token:AppToken,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:"",
//     currentToken:currentToken?currentToken:"",appToken:AppToken,
//     editType:'',postId:subCourseID,menuOrder:folderMenuOrder})
  const apiData = dispatch(createNewSubCourse({Name:subCourseName,
    token:AppToken,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:"",
    currentToken:currentToken?currentToken:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
    editType:'',postId:subCourseID,menuOrder:folderMenuOrder}));
  /* get response as Promise   */
  apiData.then(response => {
    if(response){

      // console.log(response)
      if(response?.subCourse){
    setResponseMessage(response?.message);
    setSnackbarColor("rgba(144, 202, 249,1)");
  
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
  sendBackSubCourse(response?.subCourse);
  // console.log(response?.subCourse)
  setSubCourseName(response?.subCourse?.Name);
  setSubCourseID(response?.subCourse?.ID);
  setSubCourseMenuOrder(response?.subCourse?.menuOrder)
  setShowAddFolderDetails(true)
  setShowAddFolderEdit(true)
},1000)
   }else{
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
   }
      
    // dispatch({
    //   type: "UPDATE_APP_TOKEN",
      
    //   payload:response?.course?.AppToken
    // });  
  //  console.log(response?.course);
 
   // 
   if(response?.logout){
    // pop up response?.logoutInfo
    //console.log(response?.logoutInfo)

    setResponseMessage("You are Logged Out!!!");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});

    },3000)
    
  }
/* resetting Login input Fields */

    }else{
      setResponseMessage("Something Went Wrong...");
      
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    console.error(error);
  });
 
  }
  
     
const handleUpdateSubCourse=(val,data)=>{
  let editType="", ThumbnailData="",DemoVideosData="",WhatWillULearnData="",Prerequisite="",TargetAudience="",SkillEarned="",
  JobScope="",Highlights="",FAQs="";
  if(val=="Name"){
    editType="Name";
   }if(val=="Description"){
    editType="Description";
   }if(val=="Thumbnail"){
    editType="Thumbnail";
    ThumbnailData=data;
   }if(val=="DemoVideos"){
    editType="DemoVideos";
    DemoVideosData=JSON.stringify(data);;
   }
   if(val=="WhatWillULearn"){
    editType="WhatWillULearn";
    WhatWillULearnData=JSON.stringify(data);
   }
   if(val=="Prerequisite"){
    editType="Prerequisite";
    Prerequisite=JSON.stringify(data);
   }
   if(val=="TargetAudience"){
    editType="TargetAudience";
    TargetAudience=JSON.stringify(data);
   }
   if(val=="SkillEarned"){
    editType="SkillEarned";
    SkillEarned=JSON.stringify(data);
   }
   if(val=="JobScope"){
    editType="JobScope";
    JobScope=JSON.stringify(data);
   }
   if(val=="Highlights"){
    editType="Highlights";
    Highlights=JSON.stringify(data);
   }
   if(val=="FAQs"){
    editType="FAQs";
    FAQs=JSON.stringify(data);
   }
  
   
  setLoader({status:true});

  // console.log({Name:subCourseName,
  //   token:AppToken,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:null,
  //   currentToken:currentToken?currentToken:null,appToken:AppToken,
  //   editType:editType,postId:subCourseID,menuOrder:folderMenuOrder})
      const apiData = dispatch(createNewSubCourse({Name:subCourseName,Description:subCourseDescription,Thumbnail:ThumbnailData,
        DemoVideos:DemoVideosData,
        WhatWillULearn:WhatWillULearnData,Prerequisite:Prerequisite,TargetAudience:TargetAudience,SkillEarned:SkillEarned,
        JobScope:JobScope,Highlights:Highlights,FAQs:FAQs,
      token:token,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:null,
      currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
      editType:editType,postId:subCourseID,menuOrder:folderMenuOrder}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){

        // console.log(response)
        if(response?.subCourse){
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
changeItemData(response?.subCourse?.ID,response?.subCourse);
    setSnackbarVisible(false);
    setSubCourseName(response?.subCourse?.Name);
    setSubCourseThumbnail(response?.subCourse?.Thumbnail);
    setSubCourseDemoVideos(response?.subCourse?.DemoVideos?JSON.parse(response?.subCourse?.DemoVideos):[]);
     setSubCourseWhatWillULearn(response?.subCourse?.WhatWillULearn?JSON.parse(response?.subCourse?.WhatWillULearn):[]);
    setSubCoursePrerequisite(response?.subCourse?.Prerequisite?JSON.parse(response?.subCourse?.Prerequisite):[]);
    setSubCourseTargetAudience(response?.subCourse?.TargetAudience?JSON.parse(response?.subCourse?.TargetAudience):[]);
    setSubCourseSkillEarned(response?.subCourse?.SkillEarned?JSON.parse(response?.subCourse?.SkillEarned):[]);
    setSubCourseJobScope(response?.subCourse?.JobScope?JSON.parse(response?.subCourse?.JobScope):[]);
    setSubCourseHighlights(response?.subCourse?.Highlights?JSON.parse(response?.subCourse?.Highlights):[]);
    setSubCourseFAQs(response?.subCourse?.FAQs?JSON.parse(response?.subCourse?.FAQs):[]);
       setSubCourseID(response?.subCourse?.ID);
    setShowAddFolderDetails(true)
    setShowAddFolderEdit(true)

  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
      // dispatch({
      //   type: "UPDATE_APP_TOKEN",
        
      //   payload:response?.course?.AppToken
      // });  
    //  console.log(response?.course);
   
     // 
     if(response?.logout){
      // pop up response?.logoutInfo
      //console.log(response?.logoutInfo)
  
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }



    return (<>
    
   {/* {<Loading  Load={loader?.status}/>} */}
     {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
    {FolderLook==""?<div className="" style={{alignContent:"center",textAlign:"center",marginTop:"0px",
     
     transition: 'transform 2s ease, opacity 1s ease',
   }}> <div className="userInfoLinerName"> <h2>Add SubCourse  Name</h2></div>
       
       <div className="createFolderImgTop"> 
       <div style={{height:"120px",width:"120px",borderRadius:"50%",background:"#ffffff"}}>
      <img     src={contentNewSubcourse} 
       alt="selected Img"
  style={{cursor:"pointer",width:"70px",margin:"25px",marginTop:"20px"
   
  }}/> </div> </div> 
     <div className="createFolderImgTop">
     
<textarea onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} className="createContentTextbox"  style= {{fontSize:"18px",width:"90%"}} placeholder="Add Name Of A Sub Course" type="text"
 rows={2} name="courseTitle" value={subCourseName} onChange={(e)=>setSubCourseName(e.target.value)} />
   </div> 

   {showAddFolderDetails?<>
   <div className="userInfoLinerName"> <h3>Add Sub-course Details</h3></div>
    <div className="createFolderImgTop"> <div className="gridForFolderOptionContents" style={{marginBottom:"40px",width:"95%"}}> 
    <ContentMenuCard  icon={9} title ="+ Add Description" onClickPopup={()=>{setFolderLook("description")}}  />
   <ContentMenuCard  icon={10} title ="+ Add Thumbnail" onClickPopup={()=>{setFolderLook("Thumbnail")}}  />
   <ContentMenuCard  icon={4} title ="+ Add Demo Videos" onClickPopup={()=>{setFolderLook("demoVideos")}}  />
   <ContentMenuCard  icon={1} title ="+ Learning Info" onClickPopup={()=>{setFolderLook("learningInfo")}}  />
   <ContentMenuCard  icon={3} title ="+ Pre-requisite" onClickPopup={()=>{setFolderLook("prerequisit")}}  />
   <ContentMenuCard  icon={2} title ="+ Target Audience" onClickPopup={()=>{setFolderLook("targetAudience")}}  />
   <ContentMenuCard  icon={6} title ="+ Add Skills" onClickPopup={()=>{setFolderLook("SkillEarned")}}  />
   <ContentMenuCard  icon={8} title ="+ Add Job Scope" onClickPopup={()=>{setFolderLook("JobScope")}}  />
   <ContentMenuCard  icon={5} title ="+ Add Highlights" onClickPopup={()=>{setFolderLook("Highlights")}}  />
   <ContentMenuCard  icon={7} title ="+ Add FAQs" onClickPopup={()=>{setFolderLook("faq")}}  />
   </div>  </div>  
   </>:""}
   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div  >   </div>
 
   
   <button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setopenAppDesignPopUp()}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
    id="signupBtn"> Cancel </button>
{showAddFolderEdit?
<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleUpdateSubCourse("Name","")}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Update"} </button>:
<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateSubCourse()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Click To Create"} </button>}
 </div> </div>
 
 :FolderLook=="description"?<div><div onMouseEnter={handleMouseEnter}
 onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
     <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
    
 <div className="" style={{transition: 'transform 2s ease, opacity 1s ease',}}>  
   <div className=""><div align="left" className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
          
           <div  style={{alignContent:"center",textAlign:"center",}}className="userInfoLinerName"> <h2>Add Description</h2></div> </div></div>
           <div className="createFolderImgTop">
     
     <textarea onMouseEnter={handleMouseEnter}
         onMouseLeave={handleMouseLeave} className="createContentTextbox"  style= {{fontSize:"18px",width:"90%"}} 
         placeholder="Add Description" type="text"
      rows={10} name="courseTitle" value={subCourseDescription } onChange={(e)=>setSubCourseDescription(e.target.value)} />
        </div> 
   
 <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div></div>

<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleUpdateSubCourse("Description","")}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save Info"} </button>
 </div></div>

</div></div>
   :FolderLook=="Thumbnail"?
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
 <div className=""><div align="left" className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
           </div>
           <div  style={{alignContent:"center",textAlign:"center",}}className="userInfoLinerName"> <h2>Add Thumbnail </h2></div></div>
           <div className="createFolderImgTop">

            <AddThumbnailSubCourse sendBackImage={(image)=>handleUpdateSubCourse("Thumbnail",image)} Thumbnail={subCourseThumbnail?subCourseThumbnail:"https://catalog.yogafit.com/wp-content/plugins/tutor/assets/images/placeholder.svg"} />
     </div>    
   
 <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div></div><button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
    id="signupBtn"> Back </button>

<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save Info"} </button>
 </div></div>
 
   :FolderLook=="demoVideos"?<div><div onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
    <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
   
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
<div className=""><div align="left" className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
          
           <div  style={{alignContent:"center",textAlign:"center",}}className="userInfoLinerName"> <h2>Add Demo Videos</h2></div> </div></div>
           <div style={{padding:"15px"}}>
         
    <AddDemoVideosSubCourse sendBackData={(data)=>handleUpdateSubCourse("DemoVideos",data)} data={subCourseDemoVideos}  />     </div> 
   
</div>
</div></div>:FolderLook=="learningInfo"?<div><div onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
    <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
   
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
 <div className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
           <div className="userInfoLinerName"> <h2>What Will You Learn</h2></div></div>
           
           <div style={{padding:"15px"}}>
         
         <WhatULearnSubCourse sendBackData={(data)=>handleUpdateSubCourse("WhatWillULearn",data)} data={subCourseWhatWillULearn}  />     </div> 
        
</div></div></div>:FolderLook=="prerequisit"?<div><div onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
    <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
   
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
 <div className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
           <div className="userInfoLinerName"> <h2>Add Pre-requisite Info</h2></div></div>
           
           <div style={{padding:"15px"}}>
         
         <AddPreRequsitesSubCourse sendBackData={(data)=>handleUpdateSubCourse("Prerequisite",data)} data={subCoursePrerequisite}  />     </div> 
     </div></div></div>:FolderLook=="targetAudience"?<div><div onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
    <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
   
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
 <div className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
           <div className="userInfoLinerName"> <h2>Add Target Audience</h2></div></div>
           
           <div style={{padding:"15px"}}>
         
         <AddTargetAudienceSubCourse sendBackData={(data)=>handleUpdateSubCourse("TargetAudience",data)} data={subCourseTargetAudience}  />     </div> 
  </div></div></div>:FolderLook=="SkillEarned"?<div><div onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
    <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
   
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
 <div className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
           <div className="userInfoLinerName"> <h2>Add Skills Developed After Learning</h2></div></div>
           
           <div style={{padding:"15px"}}>
         
         <AddSkillsSubCourse sendBackData={(data)=>handleUpdateSubCourse("SkillEarned",data)} data={subCourseSkillEarned}  />     </div> 
  </div></div></div>:FolderLook=="JobScope"?<div><div onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
    <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
   
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
 <div className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
           <div className="userInfoLinerName"> <h2>Add Job Scope For This Sub Course</h2></div></div>
           
           <div style={{padding:"15px"}}>
         
         <AddJobScopeSubCourse sendBackData={(data)=>handleUpdateSubCourse("JobScope",data)} data={subCourseJobScope}  />     </div> 
  </div></div></div>:FolderLook=="Highlights"?<div><div onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
    <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
   
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
 <div className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
           <div className="userInfoLinerName"> <h2>Add Highlights For This Sub Course</h2></div></div>
           
           <div style={{padding:"15px"}}>
         
         <AddHighlightsSubCourse sendBackData={(data)=>handleUpdateSubCourse("Highlights",data)} data={subCourseHighlights}  />     </div> 
  </div></div></div>:FolderLook=="faq"?<div><div onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}} style={{cursor:"pointer"}}  align="center" className="appDesignPopUpOpacity"> </div>
    <div  align="center" className="createNewSectionPopUp" style={{borderRadius: '5px',background:"#f9f9f9"}}> 
   
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
 <div className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
           <div className="userInfoLinerName"> <h2>Add FAQs</h2></div></div>
           <div style={{padding:"15px"}}>
         
         <AddFAQsSubCourse sendBackData={(data)=>handleUpdateSubCourse("FAQs",data)} data={subCourseFAQs}  />     </div> 

   </div></div></div>:""}
       </>)
}
export default CreateSubCoursePopUp;

